var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":"Producto","item-text":"nombre","item-value":"id","items":_vm.all,"prepend-icon":"mdi-propane-tank","tabindex":_vm.tabindex},model:{value:(_vm.selectedLocal),callback:function ($$v) {_vm.selectedLocal=$$v},expression:"selectedLocal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }